import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';
const withAuth = (Component) => {
    return  (props) => {
        let access_token = Cookies.get('access_token')
        if (access_token === undefined)
            return <Navigate replace to='/login'/>;

        return <Component  {...props}/>
    }
}

export default withAuth